// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2scgE","label":"Section_label__39kpD","contentWrap":"Section_contentWrap__3FJP4","footer":"Section_footer__2EZaz","footerInner":"Section_footerInner__2JSx6"};